// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import login from "../../Assets/Images/login.jpg";
// import insd from "../../Assets/Logos/insd-logo.png";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Eye, EyeOff } from "lucide-react";

// const Login = () => {
//   const [formData, setFormData] = useState({
//     phoneNumber: "",
//     password: "",
//   });
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSignin = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const signInData = {
//         ...formData,
//         userType: "admin",
//       };

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/admins/admin-login`,
//         signInData
//       );

//       if (response.data?.token) {
//         toast.success("Login successful!");
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem(
//           "adminDetails",
//           JSON.stringify(response.data.admin)
//         );

//         setTimeout(() => {
//           navigate("/courses");
//         }, 500);
//       } else {
//         toast.error(response.data?.message || "Login failed.");
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Something went wrong!");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
//       <div className="relative w-full lg:w-1/2 h-[40vh] lg:h-auto">
//         <img
//           src={login}
//           alt="login"
//           className="absolute w-full h-full object-cover"
//         />
//       </div>

//       <div className="w-full lg:w-1/2 flex items-center justify-center bg-white px-6 sm:px-10 py-14">
//         {isLoading ? (
//           <div className="w-[60vh] animate-pulse space-y-6">
//             <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
//             <div className="space-y-3">
//               <div className="h-4 w-full bg-gray-200 rounded"></div>
//               <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
//             </div>
//             <div className="space-y-3">
//               <div className="h-4 w-full bg-gray-200 rounded"></div>
//               <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
//             </div>
//             <div className="h-10 w-full bg-gray-200 rounded"></div>
//           </div>
//         ) : (
//           <div className="w-[60vh]">
//             <div className="pb-14">
//               <img src={insd} className="w-[40%] h-[40%]" alt="INSD Logo" />
//             </div>

//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold text-primaryTextColor">
//                 Welcome Back to{" "}
//                 <span className="text-secondaryTextColor">INSD</span>
//               </h2>
//             </div>

//             <form className="space-y-7" onSubmit={handleSignin}>
//               <div>
//                 <label className="block text-sm text-primaryTextColor mb-1">
//                   Phone Number
//                 </label>
//                 <div className="flex items-center border rounded-lg px-3 py-2">
//                   <input
//                     type="text"
//                     name="phoneNumber"
//                     value={formData.phoneNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d{0,10}$/.test(value)) {
//                         setFormData({ ...formData, phoneNumber: value });
//                       }
//                     }}
//                     placeholder="Enter your phone number"
//                     className="w-full outline-none text-secondaryTextColor"
//                     required
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm text-primaryTextColor mb-1">
//                   Password
//                 </label>
//                 <div className="flex items-center border rounded-lg px-3 py-2">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     placeholder="Enter your password"
//                     className="w-full outline-none text-secondaryTextColor"
//                     required
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className="text-gray-500 hover:text-gray-700 ml-2"
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               <div className="flex items-center justify-between text-sm text-gray-600">
//                 <label className="flex items-center gap-2">
//                   <input type="checkbox" className="text-secondaryTextColor" />
//                   Remember Me
//                 </label>
//                 <a href="#" className="hover:text-blue-600">
//                   Forgot Password?
//                 </a>
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-primaryBtnColor text-white py-3 rounded-lg font-semibold hover:opacity-90 transition"
//               >
//                 Login
//               </button>

//               <p className="text-center text-sm text-secondaryTextColor mt-6">
//                 Don't have any account?{" "}
//                 <a
//                   href="#"
//                   className="text-blue-600 font-semibold hover:underline"
//                 >
//                   Register
//                 </a>
//               </p>
//             </form>
//           </div>
//         )}
//       </div>

//       <ToastContainer position="top-right" autoClose={2000} />
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import login from "../../Assets/Images/login.jpg";
import insd from "../../Assets/Logos/insd-logo.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [formData, setFormData] = useState({
    phoneNumber: "",
    password: "",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const signInData = {
        ...formData,
        userType: "admin",
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/admins/admin-login`,
        signInData
      );

      if (response.data?.token) {
        toast.success("Login successful!");
        localStorage.setItem("token", response.data.token);
        localStorage.setItem(
          "adminDetails",
          JSON.stringify(response.data.admin)
        );

        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } else {
        toast.error(response.data?.message || "Login failed.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      <div className="relative w-full lg:w-1/2 h-[40vh] lg:h-auto">
        <img
          src={login}
          alt="login"
          className="absolute w-full h-full object-cover"
        />
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center bg-white px-6 sm:px-10 py-14">
        <div className="w-[60vh]">
          <div className="pb-14">
            <img src={insd} className="w-[40%] h-[40%]" alt="INSD Logo" />
          </div>

          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-primaryTextColor">
              Welcome Back to{" "}
              <span className="text-secondaryTextColor">INSD</span>
            </h2>
          </div>

          <form className="space-y-7" onSubmit={handleSignin}>
            <div>
              <label className="block text-sm text-primaryTextColor mb-1">
                Phone Number
              </label>
              <div className="flex items-center border rounded-lg px-3 py-2">
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      setFormData({ ...formData, phoneNumber: value });
                    }
                  }}
                  placeholder="Enter your phone number"
                  className="w-full outline-none text-secondaryTextColor"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm text-primaryTextColor mb-1">
                Password
              </label>
              <div className="flex items-center border rounded-lg px-3 py-2">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className="w-full outline-none text-secondaryTextColor"
                  required
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-gray-500 hover:text-gray-700 ml-2"
                  disabled={isLoading}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between text-sm text-gray-600">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="text-secondaryTextColor"
                  disabled={isLoading}
                />
                Remember Me
              </label>
              <a href="#" className="hover:text-blue-600">
                Forgot Password?
              </a>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-primaryBtnColor text-white py-3 rounded-lg font-semibold hover:opacity-90 transition disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading ? "Signing in..." : "Login"}
            </button>
          </form>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={2000} />
    </div>
  );
};

export default Login;
